'use client';
import { ReactElement, ReactNode } from 'react';
import { Session } from 'next-auth';
import { SessionProvider } from 'next-auth/react';

export interface Props {
  readonly session: Session | null;
  readonly children: ReactNode;
}

const oneHourSeconds: number = 60 * 60;

function AppLayoutContextComponent({ children, session }: Props): ReactElement {
  return (
    <SessionProvider
      session={session}
      refetchInterval={oneHourSeconds}
      refetchOnWindowFocus={false}
    >
      {children}
    </SessionProvider>
  );
}

export default AppLayoutContextComponent;
